// import storage from 'store2'

export default {
  state: {
    // sideNavScroll: 'visible'
    sideNavScroll: 'auto'
  },
  getters: {
    sideNavScroll: state => state.sideNavScroll
  },
  mutations: {
    'SIDE_NAV_SCROLL' (state, routes) {
      state.sideNavScroll = routes
    }
  },
  actions: {
    'SIDE_NAV_SCROLL' ({commit}, routes) {
      commit('SIDE_NAV_SCROLL', routes)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/side-nav/index.js